<template>
    <div class="app-container">
        <div class="login-container">
            <pang-title :text="$router.lang.get('會員 註冊')" eng="Sign up"/>
            <div class="content-container">
                <div class="img-container">
                    <img src="../../assets/images/img_tips_register_success.png">
                </div>
                <div>
                    {{ $router.lang.get('恭喜您！成功註冊 panggame 會員') }}
                </div>
                <div class="count-down">{{ $router.lang.get('{countDown} 秒後頁面將自動跳轉到下載專區', {countDown: countDown}) }}</div>
                <div  class="submit-container">
                  <div class="butt yellow" @click="goto">
                      <div>{{ $router.lang.get('遊戲下載') }}</div>
                      <div>{{ $router.lang.get('windows遊戲主程式') }}</div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { useScreenState } from '../../store';
import { PangTitle } from '../../components';


export default {
  name: "Success",
  components: {
    PangTitle,
  },
  data() {
    return {
      screenState: useScreenState(),
      countDown: 5,
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    goto() {
        this.$router.replace('/download')
    },
    countingDown () {
      if (this.countDown > 0) {
        this.countDown --
        setTimeout(this.countingDown, 1000)
      }
      else
        this.goto()
    }
  },
  mounted () {
    if (!this.screenState.user)
      this.$router.replace('/account/login')
    else {
      setTimeout(this.countingDown, 1000)
    }
  },
};
</script>

<style scoped>

.content-container {
    font-size: 32px;
    color: #333333;
    line-height: 30px;
    width: 90vw;
    max-width: 1040px;
    margin: auto;
    text-align: center;
}

.submit-container {
    margin: 36px auto;
}

.img-container > img {
    width: 214px;
    height: 163px;
    margin: 63px auto;
}

.count-down {
  font-size: 16px;
  color: #A89A60;
  line-height: 24px;
  margin-top: 14px;
}

.butt {
    max-width: 351px;
    width: calc(90vw - 20px);
    height: 99px;
    display: inline-block;
    cursor: pointer;
    
    font-weight: normal;
    color: #FFFFFF;
}



.butt > div:first-child {
    font-size: 34px;
    margin-top: 22px;
}

.butt > div:last-child {
    font-size: 14px;
}

.yellow {
    background-color: #C5A566;
}
</style>
